import React from "react";
import { bonuses } from "../data/bonuses";
export function BonusSection() {
  const total = bonuses.reduce((sum, b) => sum + b.value, 0);
  return <section className="bg-linen py-20 md:py-28" aria-labelledby="bonus-title" data-id="element-27" data-mp="1ohyclscs34yn">
      <div className="mx-auto max-w-6xl px-5" data-id="element-28" data-mp="22f3erh9dfjom">
        <div className="text-center" data-id="element-29" data-mp="1yeb54mwl7crt">
          <h2 id="bonus-title" className="font-display text-4xl uppercase leading-none text-ink md:text-6xl" data-id="element-30" data-mp="1yfctft2m5vrh">
            + 5 bonus offerts
          </h2>
          <p className="mx-auto mt-6 max-w-xl font-serif text-lg italic text-stone" data-id="element-31" data-mp="15qfbjr2be0z9">
            Réservés à ceux qui commandent aujourd'hui. Une valeur de {total} USD, incluse
            sans frais.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-6" data-id="element-32" data-mp="1eor96d1llz17">
          {bonuses.map((b, i) => <li key={b.number} className={`flex flex-col overflow-hidden rounded-2xl border border-walnut/10 bg-cream ${i < 2 ? "lg:col-span-3" : "lg:col-span-2"}`} data-id="element-33" data-mp="qydfki3d7s4i" data-mpi={i}>
              <div className={`overflow-hidden bg-sand ${i < 2 ? "aspect-[4/3]" : "aspect-square"}`} data-id="element-34" data-mp="2eqo1janze2y1">
                <img src={b.image} alt={`Couverture du bonus ${b.title}`} className="h-full w-full object-cover" loading="lazy" data-id="element-35" data-mp="2jhcwx12s7k2g" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-36" data-mp="1qus3zw6nqzws">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-wood" data-id="element-37" data-mp="1vrsau9bc06oy">
                  Bonus {b.number}
                </p>
                <h3 className="mt-2 font-serif text-xl text-ink md:text-2xl" data-id="element-38" data-mp="20q3iqei2g74j">{b.title}</h3>
                <p className="mt-2 leading-relaxed text-stone" data-id="element-39" data-mp="25s2mvqlmr82j">{b.description}</p>
                <p className="mt-auto flex items-center gap-3 pt-5 text-sm" data-id="element-40" data-mp="3c5ii1oxqzb2t">
                  <span className="text-stone line-through" data-id="element-41" data-mp="3h552ojfwntln">{b.value} USD</span>
                  <span className="rounded-full bg-walnut px-3 py-1 text-xs font-semibold uppercase tracking-wider text-linen" data-id="element-42" data-mp="1h3ezphh30v1y">
                    Offert
                  </span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}